import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

type CompletarCotasAptoParams = {
  aptoId: number;
  quantidadeCotas: number;
};

type CompletarCotasAptoResponse = {
  aptoId: number;
  nomeApto: string;
  quantidadeSolicitada: number;
  totalCotasAtivasAntes: number;
  totalCotasCriadas: number;
  totalCotasAtivasDepois: number;
  numerosCotaCriados: number[];
  cotasCriadas: unknown[];
};

export const completarCotasAptoService = async ({
  aptoId,
  quantidadeCotas,
}: CompletarCotasAptoParams) => {
  const token = validateToken();

  if (!token) {
    throw new Error("Token invalido");
  }

  const url = `${Globais.DOMINIOBACK}/cota/apto/${aptoId}/completar`;

  try {
    const response = await axios.post<CompletarCotasAptoResponse>(
      url,
      { quantidadeCotas },
      {
        headers: { Authorization: token.AuthStr },
      }
    );

    return response.data;
  } catch (error: any) {
    if (error.response?.data) {
      throw error.response.data;
    }

    throw new Error("Erro ao completar cotas do apartamento");
  }
};
